import { useContext, useEffect, useState } from 'react';
import UserPreferencesContext from '@/context/UserPreferencesContext';
import { Translator } from '@/utils/translation';

export const useGoogleTranslator = (text: string) => {
  const {
    language: { code: to },
    defaultLanguage,
    googleApiKey,
  } = useContext(UserPreferencesContext);
  const [translation, setTranslation] = useState<string>('');

  const translate = async (value: string) => {
    const translator = new Translator(defaultLanguage, googleApiKey);
    const translatedText = await translator.translate(value, to);
    setTranslation(translatedText);
  };


  useEffect(() => {
    translate(text || '');
  }, [to, text]);

  return translation || text;
};
